import { defineComponent as _defineComponent } from 'vue'
import { AbCheckbox } from '../../components/ui';
import type { Field } from '../types';
import { getAttributeValue } from '../utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormFieldCheckbox',
  props: {
    value: null,
    field: null,
    error: null,
    disabled: { type: Boolean }
  },
  emits: ["input", "validate"],
  setup(__props: any) {





return { __sfc: true,AbCheckbox, getAttributeValue }
}

})